import { SprinklesElement } from "sprinkles-js";

export default class ScrollingLoaderElement extends SprinklesElement {
  static tagName = "scrolling-loader";
  static refs = ["link"];

  constructor() {
    super();
    this.observer = new IntersectionObserver(this.#onAppear.bind(this));
  }

  afterConnected() {
    if (window.location.search.includes("disable-scroll=1")) return;

    this.observer.observe(this);
  }

  beforeDisconnect() {
    this.observer.unobserve(this);
  }

  #onAppear(entries) {
    // We only expect one entry, since we only have one object and one threshold
    const entry = entries.at(0);
    if (entry.intersectionRatio > 0) this.refs.link.click();
  }
}
